// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Note from '../_raw/ui/icon_note.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Note);
